var _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIkonKartDefaultRdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_2",
    "data-name": "Component 16 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 37.5,
    cy: 36,
    rx: 37.5,
    ry: 36,
    fill: "#ac1720",
    opacity: 0.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 22.5,
    cy: 21.5,
    rx: 22.5,
    ry: 21.5,
    transform: "translate(15 15)",
    fill: "#ac1720"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonKartDefaultRdt);
export default __webpack_public_path__ + "static/media/Ikon-kart-default-rødt.38d7c6f47dcc3df9345b74d1b9218abb.svg";
export { ForwardRef as ReactComponent };